import React from 'react';

const PrivacyPage = () => {
  return (
    <div className="container mx-auto p-6 text-white">
      <h1 className="text-3xl font-bold text-center mb-6 mt-10">Məxfilik Siyasəti</h1>
      <p className="text-xl mb-4"><strong>SkyCinema</strong></p>
      <p className="mb-4">Qüvvəyə minmə tarixi: 11/18/2024</p>
      
      <p className="mb-4">
        SkyCinema (“Biz”, “Bizim”, “Bizim”) məxfiliyinizə hörmətlə yanaşır və şəxsi məlumatlarınızı qorumağa sadiqdir.
        Bu Məxfilik Siyasəti məlumatlarınızı necə topladığımızı, istifadə etdiyimizi və emal etdiyimizi və məlumatlarınızla bağlı hansı hüquqlara malik olduğunuzu izah edir.
      </p>
      
      <h2 className="text-2xl font-semibold mt-6 mb-4">1. Məlumatların toplanması</h2>
      <p className="mb-4">
        Haqqınızda aşağıdakı məlumatları toplaya və emal edə bilərik:
        <ul className="list-disc ml-6">
          <li>Şəxsi məlumatlar: ad, soyad, e-poçt ünvanı, telefon nömrəsi.</li>
          <li>Maliyyə məlumatları: bank kartları və ya ödəniş sistemlərinin məlumatları.</li>
          <li>Texniki məlumat: IP ünvanı, brauzer növü, cihazınız haqqında məlumat, kukilər.</li>
          <li>Əməliyyatlar haqqında məlumat: alış tarixi, ödənişlərin tarixləri və məbləğləri.</li>
        </ul>
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">2. Məlumatların istifadəsi</h2>
      <p className="mb-4">
        Məlumatlarınızı aşağıdakı məqsədlər üçün istifadə edirik:
        <ul className="list-disc ml-6">
          <li>Sifarişlərinizi emal edin və rəqəmsal məzmunun çatdırılmasını təmin edin.</li>
          <li>Sifarişlər, ödəniş və ya texniki dəstək ilə bağlı sizinlə əlaqə saxlamaq.</li>
          <li>Veb saytımızda istifadəçi təcrübəsinin təkmilləşdirilməsi.</li>
          <li>Marketinq poçtları (sizin razılığınızla).</li>
          <li>Qanunlara və qaydalara uyğunluq.</li>
        </ul>
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">3. Məlumatların üçüncü tərəflərə ötürülməsi</h2>
      <p className="mb-4">
        Məlumatlarınızı aşağıdakılarla paylaşa bilərik:
        <ul className="list-disc ml-6">
          <li>Əməliyyatların işlənməsi üçün ödəniş sistemləri.</li>
          <li>Hostinq provayderləri və xidmət təminatçıları (məsələn, saytın fəaliyyətini təmin etmək üçün).</li>
          <li>Qanunla tələb olunarsa, dövlət orqanları.</li>
        </ul>
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">4. Kukilər</h2>
      <p className="mb-4">
        Biz kukilərdən istifadə edirik:
        <ul className="list-disc ml-6">
          <li>Tercihlərinizi saytda saxlamaq.</li>
          <li>Trafik və istifadəçi davranışının təhlili.</li>
        </ul>
        Siz brauzerinizin parametrlərində kukiləri söndürə bilərsiniz, lakin bu, saytımızın bəzi xüsusiyyətlərinə girişinizi məhdudlaşdıra bilər.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">5. Məlumat təhlükəsizliyi</h2>
      <p className="mb-4">
        Biz məlumatlarınızı icazəsiz giriş, itki və ya dəyişiklikdən qorumaq üçün ağlabatan tədbirlər görürük. Bununla belə, məlumatın İnternet üzərindən ötürülməsi tamamilə təhlükəsiz ola bilməz, ona görə də biz məlumatların tam qorunmasına zəmanət verə bilmərik.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">6. Hüquqlarınız</h2>
      <p className="mb-4">
        Sizin hüququnuz var:
        <ul className="list-disc ml-6">
          <li>Məlumatınıza daxil olun və onun surətini tələb edin.</li>
          <li>Məlumatlarınızın düzəldilməsini və ya silinməsini tələb edin.</li>
          <li>Məlumatların emalına razılığı geri götürün (əgər emal razılığa əsaslanırsa).</li>
          <li>Yerli məlumatların mühafizəsi orqanına şikayət verin.</li>
        </ul>
        Hüquqlarınızı həyata keçirmək üçün bizimlə skycinema.az@gmail.com elektron poçtu ilə əlaqə saxlayın.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">7. Üçüncü tərəf saytlarına keçidlər</h2>
      <p className="mb-4">
        Saytımız üçüncü tərəf mənbələrinə keçidlər ehtiva edə bilər. Biz bu cür saytların məxfilik təcrübələrinə görə məsuliyyət daşımırıq.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">8. Məxfilik siyasətinə dəyişikliklər</h2>
      <p className="mb-4">
        Biz bu Məxfilik Siyasətinə dəyişiklik etmək hüququnu özümüzdə saxlayırıq. Yenilənmiş versiya son yeniləmənin tarixi göstərilməklə saytda dərc olunacaq.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">9. Əlaqələr</h2>
      <p className="mb-4">
        Suallarınız və ya istəkləriniz varsa, bizimlə əlaqə saxlayın:
        <ul className="list-disc ml-6">
          <li>E-poçt: skycinema.az@gmail.com</li>
          <li>Ünvan: EGP arena</li>
        </ul>
      </p>

      <p className="mt-4 mb-10">SkyCinema-dan istifadə etdiyiniz üçün təşəkkür edirik!</p>
    </div>
  );
};

export default PrivacyPage;
